import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

registerLocaleData(localeEs);
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { appRoutes } from './app.routes';
import { jwtInterceptor } from './app/core/interceptors/jwt.interceptor';
import { loadingInterceptor } from './app/core/interceptors/loading.interceptor';

// Preset personalizado Usina: Extiende Aura con Verde Neón (#00ff00) como color primario
const UsinaPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50:  '{ green.50 }',
            100: '{ green.100 }',
            200: '{ green.200 }',
            300: '{ green.300 }',
            400: '{ green.400 }',
            500: '#00ff00', // Verde Neón Usina
            600: '#00cc00',
            700: '#009900',
            800: '#006600',
            900: '#003300',
            950: '#001a00'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '#00ff00',
                    inverseColor: '#000000',
                    hoverColor: '#00cc00',
                    activeColor: '#009900'
                },
                highlight: {
                    background: '#000000',
                    focusBackground: '#1a1a1a',
                    color: '#00ff00',
                    focusColor: '#00ff00'
                }
            },
            dark: {
                primary: {
                    color: '#00ff00',
                    inverseColor: '#000000',
                    hoverColor: '#00cc00',
                    activeColor: '#009900'
                },
                highlight: {
                    background: '#00ff00',
                    focusBackground: '#00cc00',
                    color: '#000000',
                    focusColor: '#000000'
                }
            }
        }
    }
});

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([jwtInterceptor, loadingInterceptor])),
        provideAnimationsAsync(),
        MessageService,
        { provide: LOCALE_ID, useValue: 'es' },
        providePrimeNG({
            theme: {
                preset: UsinaPreset,
                options: {
                    darkModeSelector: '.app-dark'
                }
            }
        })
    ]
};
